import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';

import s from './Banner.scss';

export interface Props {}

const Banner: FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <img
        width="565"
        height="168"
        src={Url.staticCDNLink('eclipse/package-picker/core-banner.svg')}
        alt=""
        className={s['core']}
      />
      <div className={s['powered']}>{t('packagePicker.banner.header')}</div>

      <div className={s['credits']}>
        <a
          href={
            'https://www.deviantart.com/lorddoomhammer/art/Departure-679834588'
          }
        >
          {t('packagePicker.banner.authorCredits')}
        </a>
      </div>
    </div>
  );
};
Banner.displayName = 'Banner';

export default Banner;
